import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import RelativeLink from "app/pages/.shared/RelativeLink";
import IconHome from "app/pages/.shared/static/icons/IconHome";
import SvgIconMagnifyingGlassBold from "app/pages/.shared/IconMagnifyingGlassBold";
import IconLock from "app/pages/.shared/IconLock";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const AccountAsideMenuFooter = ({ showSmartDPOnRootUrl = false }) => {
	return (
		<>
			{showSmartDPOnRootUrl ? (
				<>
					<li className="sub-nav">
						<RelativeLink
							to={{ pathname: "/listing" }}
							className="sub-nav__main sub-nav__main--link"
						>
							<div className="sub-nav__label">
								<IconLock height={24} width={20} />
								<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
									<FormattedMessage id="sdp.menu.item.flashsales" />
								</Typography>
							</div>
						</RelativeLink>
					</li>
					<li className="sub-nav">
						<RelativeLink
							to={{ pathname: "/" }}
							className="sub-nav__main sub-nav__main--link"
						>
							<div className="sub-nav__label">
								<SvgIconMagnifyingGlassBold height={29} />
								<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
									<FormattedMessage id="sdp.menu.item.search.trip" />
								</Typography>
							</div>
						</RelativeLink>
					</li>
				</>
			) : (
				<li className="sub-nav">
					<RelativeLink
						to={{ pathname: "/listing" }}
						className="sub-nav__main sub-nav__main--link"
					>
						<div className="sub-nav__label">
							<IconHome height={20} style={{ marginRight: "15px" }} />
							<Typography variant={TYPOGRAPHY_VARIANTS.LARGE} isBold>
								<FormattedMessage id="menu.mobile.all.sales" />
							</Typography>
						</div>
					</RelativeLink>
				</li>
			)}
		</>
	);
};

AccountAsideMenuFooter.propTypes = {
	showSmartDPOnRootUrl: PropTypes.bool,
};

export default memo(AccountAsideMenuFooter);
